<template>
    <div class="form-group" v-loading="isBusy">
        <label>Files & Notes</label>
        <div style="margin: 10px 0">
            <btn :click="addNote" icon="fas fa-plus">Add Note</btn>
            <BillingNotesUploadFile :budget_period_id="budgetPeriodId" @changed="refresh"></BillingNotesUploadFile>
        </div>
        <table v-if="notes.length > 0" style="width: 100%;">
            <tr>
                <td>
                    <template v-for="note in notes">
                        <div class="bil-note" v-if="note.type === 'note'">
                            <div class="bil-note-content">{{ note.text }}</div>
                            <div class="bil-note-footer">
                                {{ note.created_by }}
                                · {{ note.created_at }}
                                · <a href="#" @click.prevent="editNote(note)">edit</a>
                                · <a href="#" @click.prevent="removeNote(note)">delete</a>
                            </div>
                        </div>
                        <div class="bil-file" v-else-if="note.type === 'file'">
                            <a :href="note.file_url" target="_blank" class="bil-file-download">{{ note.file_name }}</a>
                            <div class="bil-note-footer">
                                {{ note.created_by }}
                                · {{ note.created_at }}
                                · <a href="#" @click.prevent="removeFile(note)">delete</a>
                            </div>
                        </div>
                    </template>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
import BillingNotesUploadFile from './../../BudgetNotes/vue/billing-notes-upload-file';

export default {
    components: { BillingNotesUploadFile },
    props: {
        notes: { type: [Object, Array], required: true },
        budgetPeriodId: { type: [String, Number], required: true },
    },
    data() {
        return {
            isBusy: false,
        };
    },
    methods: {
        removeNote(note) {
            this.isBusy = true;
            return axios.post(url(`admin/budget-note/${note.budget_period_id}/note/${note.id}/remove`))
                        .then(response => {
                            this.$emit('noted', _.filter(this.notes, function (n) { return n.id !== note.id; }));
                        })
                        .finally(() => {
                            this.isBusy = false;
                        });
        },
        removeFile(file) {
            this.isBusy = true;
            return axios.post(url(`admin/budget-file/${file.budget_period_id}/file/${file.id}/remove`))
                        .then(response => {
                            this.$emit('noted', _.filter(this.notes, function (f) { return f.id !== file.id; }));
                        })
                        .finally(() => {
                            this.isBusy = false;
                        });
        },
        addNote() {
            return this.$prompt('', 'Note', {
                confirmButtonText: 'Add',
                cancelButtonText: 'Cancel',
                inputType: 'textarea',
                inputValue: '',
                closeOnClickModal: false,
            }).then(({ value }) => {
                this.isBusy = true;
                return axios.post(url(`admin/budget-note/${this.budgetPeriodId}/add`), {
                    text: value,
                }).then(response => {
                    return this.refresh();
                });
            });
        },
        editNote(note) {
            return this.$prompt('', 'Note', {
                confirmButtonText: 'Save',
                cancelButtonText: 'Cancel',
                inputType: 'textarea',
                inputValue: note.text,
                closeOnClickModal: false,
            }).then(({ value }) => {
                this.isBusy = true;
                return axios.post(url(`admin/budget-note/${note.budget_period_id}/note/${note.id}/save`),
                    { text: value })
                            .then(response => {
                                this.$emit('noted', _.map(this.notes, function (n) {
                                    if (n.id === note.id) {
                                        n.text = value;
                                    }
                                    return n;
                                }));
                            })
                            .finally(() => {
                                this.isBusy = false;
                            });
            });
        },
        refresh() {
            this.isBusy = true;
            return axios.get(url(`admin/budget-note/${this.budgetPeriodId}/list`))
                        .then(response => {
                            this.$emit('noted', response.data.notes);
                        })
                        .finally(() => {
                            this.isBusy = false;
                        });
        },
    },
};
</script>
